import { FiArrowRight } from "react-icons/fi";
import { imgLinks } from "../../../public/assets/assetLinks.ts";
import { Button } from "@/components/ui";
import { motion } from "motion/react";
import { Button as MovingButton } from "../../components/ui/button/moving-border";
import { useNavigate } from "react-router-dom";

export const Hero = () => {
  function gotoGetStarted (){
    window.open('https://app.qoonity.com/auth/register','_blank');
  }

  function gotoLogin (){
    window.open('https://app.qoonity.com/auth/login','_blank');
  }
  return (
    <motion.div
      animate={{  transition: { duration: 2, ease: "easeIn" } }}
      className="items-center lg:px-10 px-5 py-10 flex flex-col text-center justify-center"
    >
      <div className="items-center justify-center flex flex-col pb-20">
        <MovingButton className="bg-[#7505054D] w-full rounded-full flex-row flex gap-2 border border-[#FFFFFF24] p-1 items-center text-white">
          <button className="bg-[#1F2228] p-1 text-white rounded-full">
            <p className="text-xs font-medium">Update</p>
          </button>
          <p className="text-xs font-medium">Qoonity code generator</p>
          <FiArrowRight />
        </MovingButton>
        <div className=" space-y-5 items-center justify-center flex flex-col pt-5">
          <h3 className="bg-gradient-to-r from-[#F08E7F] max-w-4xl inline-block text-transparent to-[#A00B0B] bg-clip-text">
            Code Smarter, Build Faster with Qoonity
          </h3>
          <h2 className="max-w-2xl  text-[#FFFFFF99]">
            Qoonity is your AI-powered coding assistant that turns prompts into
            production-ready code in Java, Kotlin, and Python— instantly.
          </h2>
          <div className="items-center justify-center flex gap-5 ">
            <Button
              label="Try Qoonity Now!"
              state="primary"
              onClick={() => gotoLogin()}
            />
            <Button
              label="Sign Up Now!"
              state="secondary"
              onClick={() => gotoGetStarted()}
            />
          </div>
        </div>
      </div>
      <div className="drop-shadow-3xl  drop-shadow-[#970E0E40]">
        <img src={imgLinks.qoonitysc} loading="lazy" />
      </div>
    </motion.div>
  );
};
